import { render, staticRenderFns } from "./BreakoutRoomsTab.vue?vue&type=template&id=46a88346&scoped=true"
import script from "./BreakoutRoomsTab.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsTab.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsTab.vue?vue&type=style&index=0&id=46a88346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a88346",
  null
  
)

export default component.exports